import { CLASSIFICATION_TYPE, PAGE_TYPE } from "../../constants";
import { eventTrackPayloadCreator } from "../../helpers/eventPayloadCreator";
import { EventData, EventPayload } from "../../types";

export interface EditAddressCTAClickedPayload extends EventPayload {
  content: {
    title: string;
  };
  orderId: string;
  productId: string;
}

const EditAddressCtaClickedEventData: EventData = {
  eventName: "Edit Address CTA Clicked",
  classification: CLASSIFICATION_TYPE.experienceEvent,
  pageType: PAGE_TYPE.orderHistory,
};

export const createEditAddressCTAClickedEventPayload =
  eventTrackPayloadCreator<EditAddressCTAClickedPayload>(
    EditAddressCtaClickedEventData,
  );
